import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import routes from '../../routes';
import { RouteObject } from '../../routes/router';
import flattenRoutes from '../../util/flattenRoutes';

const generateCrumbs = (routesObject: Omit<RouteObject, 'routes'>[], path: string) =>
  routesObject
    .filter((route) => route.path && path.includes(route.path))
    .filter((route) => !!route.breadcrumb)
    .map((route) => ({
      label: route.breadcrumb!,
      href: route.path === path ? undefined : route.path,
    }));

export const useCrumbs = () => {
  const { path } = useRouteMatch();

  const getCrumbs = React.useCallback(() => {
    const flattenedRoutes = flattenRoutes(routes);
    return generateCrumbs(flattenedRoutes, path);
  }, [routes, path]);

  return getCrumbs();
};
